import styled from "styled-components"

import { Typography } from "components/common"

const PageTitle = styled(Typography).attrs((props) => ({
  as: "h1",
  color: "neutral",
  fontSize: props.subtitle ? "18px" : { _: 30, tablet: 26 },
  fontWeight: 300,
  marginTop: props.subtitle ? { _: 1, tablet: 2 } : "",
  mb: 4,
  pb: 2,
  textAlign: "center",
  ...(props.isNewDesign && {
    color: "black",
    fontSize: "32px",
    fontWeight: 700,
    lineHeight: "36px",
    pb: 0,
  }),
  ...props,
}))`
  ${(props) =>
    !props.isNewDesign &&
    `
      background-image: linear-gradient(transparent, #ababab);
      background-position: bottom center;
      background-repeat: no-repeat;
      background-size: 13% 1px;
    `}
`

export default PageTitle
